var newQusArrData = {
    "en": [
        {
            ques: "How can I change my name?",
            answer: null,
            answerItem: [
                {
                    itemText: "Press on the pen icon on the top right of the page."
                },
                {
                    itemText: "Press on Nickname and change it."
                },
                {
                    itemText: "You can change it one time every 24 hours."
                },
            ]
        },
        {
            ques: "How can I change gender?",
            answer: null,
            answerItem: [
                {
                    itemText: "Press on the pen icon on the top right of the page."
                },
                {
                    itemText: "Press on Gender and change it."
                },
                {
                    itemText: "You can change it twice maximum."
                }
            ]
        },
        {
            ques: "How can I change my avatar?",
            answer: null,
            answerItem: [
                {
                    itemText: "Press on the pen icon on the top right of the page."
                },
                {
                    itemText: "Press on your photo."
                },
                {
                    itemText: "Press on this icon (…) on the top right of the page."
                },
                {
                    itemText: "Choose (take photo – choose from album)."
                },
                {
                    itemText: "If you upload a lot of photos you can press on it and set as profile photo."
                },
            ]
        },
        {
            ques: "How can I gain more followers?",
            answer: null,
            answerItem: [
                {
                    itemText: "Broadcast daily periodically."
                },
                {
                    itemText: "Use an attractive name and image to attract viewers to watch your broadcast."
                },
                {
                    itemText: "Be friendly in your broadcast."
                },
                {
                    itemText: "Make the broadcast entertaining by showing your talents and skills."
                },
            ]
        },
        {
            ques: "How can I control notifications?",
            answer: null,
            answerItem: [
                {
                    itemText: "Press on the settings from the home page."
                },
                {
                    itemText: "Press on notification."
                },
                {
                    itemText: "You can switch on/off notifications from loops management and all people you are following."
                },
            ]
        },
        {
            ques: "How can I level up?",
            answer: null,
            answerItem: [
                {
                    itemText: "Watch live (5 mins = 1 EXP)."
                },
                {
                    itemText: "Send gifts (1 coin = 5 EXP)."
                },
                {
                    itemText: 'Watch live (5 mins = 1 EXP).'
                },
                {
                    itemText: "Receive diamonds (2 diamonds = 1 EXP)."
                },
                {
                    itemText: "Shop in store (1 diamond = 5 EXP)."
                },
                {
                    itemText: "Go live (10 mins = 10 EXP)."
                },
            ]
        },
        {
            ques: "I can’t login my account due to verification code issue?",
            answer: null,
            answerItem: [
                {
                    itemText: "Make sure that you entered your correct phone number."
                },
                {
                    itemText: "Make sure that there no problem in your sim card or messaging service."
                },
                {
                    itemText: "Make sure that you have strong signal."
                },
                {
                    itemText: "Try another phone."
                },
                {
                    itemText: "If issue still exist you must contact us through email (Help@loopslive.com) to check the issue."
                },
            ]
        },
    ],
    "ar": [
        {
            ques: " كيفية تغيير الاسم؟",
            answer: null,
            answerItem: [
                {
                    itemText: "الضغط على علامة القلم اعلى الشمال من الصفحة الشخصية."
                },
                {
                    itemText: 'الضغط على كلمة "اللقب" والتغيير.'
                },
                {
                    itemText: "يمكنك التغيير مرة واحدة كل 24 ساعة."
                },
            ]
        },
        {
            ques: " كيفية تغيير الجنس؟",
            answer: null,
            answerItem: [
                {
                    itemText: "الضغط على علامة القلم أعلى اليسار من الصفحة الشخصية."
                },
                {
                    itemText: "الضغط على كلمة الجنس."
                },
                {
                    itemText: "يمكنك تغيير الجنس مرتين كحد أقصى."
                },
            ]
        },
        {
            ques: "كيفية تغيير صورة البروفايل؟",
            answer: null,
            answerItem: [
                {
                    itemText: "الضغط على علامة القلم اعلى الشمال من الصفحة الشخصية."
                },
                {
                    itemText: "الضغط على الصورة الشخصية."
                },
                {
                    itemText: "الضغط على الثلاث نقاط المتواجدة اعلى الشمال."
                },
                {
                    itemText: "اختيار (التقط صورة من الكاميرا – اختر من البوم الصور)."
                },
                {
                    itemText: "إذا كان هناك اكثر من صورة يمكنك الضغط على واحدة منهم واختيارها كصورة البروفايل."
                },
            ]
        },
        {
            ques: "كيف احصل على الكثير من المتابعين؟",
            answer: null,
            answerItem: [
                {
                    itemText: "قم بالبث بصورة دائمة ولفترة لا تقل عن 30 دقيقة."
                },
                {
                    itemText: "استخدم صورة بث ذو طابع جذاب وعنوان شيق للبث ايضا حيث ان هذا يشجع المستخدمين لمتابعة بثك."
                },
                {
                    itemText: "كن ودودا ومرحا في بثك وتجنب الاساءات والمشاحنات."
                },
                {
                    itemText: "اجعل بثك شيقا واستعرض مواهبك وافكارك وتحدث عن مواضيع شيقة."
                },

            ]
        },
        {
            ques: "كيفية التحكم في الاشعارات؟",
            answer: null,
            answerItem: [
                {
                    itemText: "الضغط على الاعدادات من خلال الصفحة الشخصية."
                },
                {
                    itemText: "الضغط على التنبيهات."
                },
                {
                    itemText: "يمكنك ايقاف جميع الاشعارات القادمة من ادارة اللوبس او لجميع الاشخاص الذين تتابعهم بشكل فردى او جماعي."
                },
            ]
        },
        {
            ques: "كيفية رفع المستوي الخاص بي؟",
            answer: null,
            answerItem: [
                {
                    itemText: "شحن الكوينز (1 كوين = 5 نقاط)."
                },
                {
                    itemText: "ارسال هدايا (1 كوين = 5 نقاط)."
                },
                {
                    itemText: "مشاهدة البث الحي (5 دقائق = 1 نقطة)."
                },
                {
                    itemText: "استلام الماس (2 ماسه = 1 نقطة)."
                },
                {
                    itemText: 'الشراء من المتجر (1 ماسه = 5 نقطة)'
                },
                {
                    itemText: 'القيام بالبث (10 دقائق = 10 نقاط)'
                }
            ]
        },
        {
            ques: "مشكلة عدم استلام كود التحقق؟",
            answer: null,
            answerItem: [
                {
                    itemText: "التأكد من إدخال رقم الهاتف بشكل صحيح."
                },
                {
                    itemText: "إزالة الشريحة برقم الهاتف وإعادة وضعها."
                },
                {
                    itemText: "تفعيل الرسائل الدعائية من شركة الهاتف الخاصة بك، لذا نرجو التواصل مع شركة الهاتف والتأكد من عدم وجود أي مشكلة بشريحة الهاتف أو بخدمة الرسائل."
                },
                {
                    itemText: "التأكد من تواجدك في مكان به شبكة هاتف قوية."
                },
                {
                    itemText: 'تجربة جهاز هاتف أخر "ضع الشريحة بجهاز أخر" و حاول دخول حسابك من هذا الهاتف إذا وصل رمز التأكيد ذلك يعني أن هناك مشكلة ما بالهاتف الخاص بك، أما إذا لم تصل نرجو التواصل معنا من خلال البريد الإلكتروني(help@loopslive.com)  لكي نتحقق من الأمر أكثر.'
                },
            ]
        },
    ]
}


var popularQuesData = {
    "en": [
        {
            title: "Account",
            desc: null,
            detailArr: [
                {
                    ques: "How can I delete loops account?",
                    answer: "Loops account is completely linked to the channel that you have used to create it (Facebook, Twitter, Gmail, or phone number) and there is no option to change it.",
                    answerItem: [],
                },
                {
                    ques: "How can I change my Loops ID?",
                    answer: "You can change it after activating the VIP badge.",
                    answerItem: [],
                },
                {
                    ques: "How can I add or delete my connected phone number?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "From the main page, select your profile photo."
                        },
                        {
                            itemText: "Choose settings, then manage my account."
                        },
                        {
                            itemText: "Choose a mobile number."
                        },
                        {
                            itemText: "Select add or delete mobile number."
                        },
                    ]
                },
                {
                    ques: "How can I change login method?",
                    answer: "We actually have no option in the application to delete the account as the account sign up process is through (Facebook, Twitter, Google+, phone number).",
                    answerItem: [
        
                    ]
                },
                {
                    ques: "How can I set a password to loops account?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "Through login by phone number."
                        },
                        {
                            itemText: "Press on set a password."
                        },
                        {
                            itemText: "Pick a password containing 6 (letters -  numbers)."
                        },
                        {
                            itemText: "Press on confirm."
                        },
                    ]
                },
            ]
        },
        {
            title: "Ban",
            desc: null,
            detailArr: [
                {
                    ques: "What are the banning reasons?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "Racism or political talks."
                        },
                        {
                            itemText: "Invitation users to another application or leave it."
                        },
                        {
                            itemText: "Hacking accounts and fraud."
                        },
                        {
                            itemText: "Insulting any user or group."
                        },
                    ]
                },
                {
                    ques: "How can I report from the application?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "Press on the avatar related to offensive account."
                        },
                        {
                            itemText: 'Press on “report”.'
                        },
                        {
                            itemText: "Choose offense type then submit."
                        },
                    ]
                },
            ]
        },
        {
            title: "Payment",
            desc: null,
            detailArr: [
                {
                    ques: "How can I top-up?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "Press on top up coins from the home page."
                        },
                        {
                            itemText: "Choose amount of coins."
                        },
                        {
                            itemText: "Add credit or debit card for payment."
                        },
                    ]
                },
                {
                    ques: "I can’t top-up, what should I do?",
                    answer: "You can send to help@loopslive.com the below data in details in order to do further investigations",
                    answerItem: [
                        {
                            itemText: "The amount of money spent on purchasing the coins."
                        },
                        {
                            itemText: "The date and time of purchase."
                        },
                        {
                            itemText: "Which package of coins you tried to purchase."
                        },
                        {
                            itemText: "A screen shot or a photo of the proof of purchase (which you can get from your google play or app store)."
                        },
                        {
                            itemText: "Loops ID account."
                        },
                    ]
                },
                {
                    ques: "How can I make a cash out?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "Press on my diamonds from the home page."
                        },{
                            itemText: "Press on convert to coins."
                        },
                        {
                            itemText: "Press on cash out to receive your money within 21 working days."
                        },
                        {
                            itemText: "Signup a payoneer account for payment transfer."
                        },
                        {
                            itemText: "Minimum cash out amount 90 USD and maximum 2,000 USD and reach level 10."
                        },
                        {
                            itemText: "Receive the payment on your payoneer account after we approve then transfer it to your bank account."
                        },
                        {
                            itemText: "You can make a cash out one time every 30 day."
                        },
                    ]
                },
            ]
        },
        {
            title: "Broadcast",
            desc: null,
            detailArr: [
                {
                    ques: "How can I go live?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "Press on this icon (+)."
                        },
                        {
                            itemText: "Choose the live type (sound – video)."
                        },
                    ]
                },
                {
                    ques: "How can I become a guest in live?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "You have to be level 2."
                        },
                        {
                            itemText: 'Join any live streaming and press on (-) on the right of the page.'
                        },
                        {
                            itemText: "Choose guest video and send request."
                        },
                        {
                            itemText: "Wait the acceptance from the host."
                        },
                    ]
                },
                {
                    ques: "How can I go live in private room?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "Press on this icon (+)."
                        },
                        {
                            itemText: "Choose the live type (sound – video)."
                        },
                        {
                            itemText: "Enable private mood."
                        },
                        {
                            itemText: "Choose the suitable package"
                        },
                    ]
                },
                {
                    ques: "How can I be a broadcaster?",
                    answer: "You can be a broadcaster after gaining host badge:",
                    answerItem: [
                        {
                            itemText: "Bronze (When you get 30,000 diamonds per month)."
                        },
                        {
                            itemText: "Sliver (When you get 100,000 diamonds per month)."
                        },
                        {
                            itemText: "Gold (When you get 1,000,000 diamonds per month)."
                        },
                    ]
                },
                {
                    ques: "I can’t go live?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "Delete the app and install it again"
                        },
                        {
                            itemText: "If still the same, send a screenshot of the error message that appears on your phone screen."
                        },
                        {
                            itemText: "The time and date when the issue started to happen."
                        },
                        {
                            itemText: "Send the above data to help@loopslive.com."
                        },
                    ]
                },
            ]
        },
        {
            title: "Club",
            desc: null,
            detailArr: [
                {
                    ques: "How can I create the club?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "Press on “Go live”  button."
                        },
                        {
                            itemText: "Press on the club sign beside the comments."
                        },
                        {
                            itemText: "Choose upgrade for free."
                        },
                        {
                            itemText: "Choose club name and category then press on create."
                        }
                    ]
                },
                {
                    ques: "How can I subscribe to a club?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "Press on the “clubs“ button in your profile."
                        },
                        {
                            itemText: "Press on explore membership."
                        },
                        {
                            itemText: "Choose the suitable club package ( Basic -Standard - premium -premium gold)."
                        },
                        {
                            itemText:"Press on subscribe now."
                        },
                        {
                            itemText: "Add credit or debit card for payment."
                        }
                    ]
                },
                {
                    ques: "What are the club subscription privileges?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "Free flying messages."
                        },
                        {
                            itemText: "Free exclusive gifts."
                        },
                        {
                            itemText: "20% additional EXP."
                        },{
                            itemText:"Special Entry effect."
                        },
                        {
                            itemText: "Exclusive fan badge."
                        }
                    ]
                },
                {
                    ques: "I can’t join any club?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "Send to help@loopslive.com a screenshot from the message that appeared to you while try to join any club."
                        },
                        {
                            itemText: 'Send a screenshot from your subscription and receipt.'
                        },
                    ]
                },
            ]
        },
        {
            title: "VIP",
            desc: null,
            detailArr: [
                {
                    ques: "How can I be a VIP?",
                    answer: "You can be a VIP user after gaining VIP badge:",
                    answerItem: [
                        {
                            itemText: "Knight (total spending coins = 500,000 coins from the Registered Time)."
                        },
                        {
                            itemText: "Lord (total spending coins = 1,500,000 coins from the Registered Time)."
                        },
                        {
                            itemText: "Vizier (total spending coins = 3,125,000 coins from the Registered Time)."
                        },
                        {
                            itemText: "Prince (total spending coins = 12,500,000 coins from the Registered Time)."
                        },
                        {
                            itemText: "King (total spending coins = 35,000,000 coins from the Registered Time)."
                        },
                    ]
                },
                {
                    ques: "How can I maintain my badge?",
                    answer: "You can maintain your VIP badge monthly by spending the below:",
                    answerItem: [
                        {
                            itemText: "Knight (required spending coins = 50,000 coins)."
                        },
                        {
                            itemText: "Lord (required spending coins = 150,000 coins)."
                        },
                        {
                            itemText: "Vizier (required spending coins = 312,500 coins)."
                        },
                        {
                            itemText: "Prince (required spending coins = 1,000,000 coins)."
                        },
                        {
                            itemText: "King (required spending coins = 2,100,000 coins)."
                        },
                    ]
                },
            ]
        },
        {
            title: 'Guardian knight',
            desc: null,
            detailArr: [
                {
                    ques: "What are the guardian knight privileges?",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "Guardian avatar."
                        },
                        {
                            itemText: "Special entry effect."
                        },
                        {
                            itemText: "Special message bubble."
                        },
                        {
                            itemText: "5X EXP based on bidding price."
                        }
                    ]
                }
            ]
        }
    ],
    "ar": [
        {
            title: "الحساب",
            desc: null,
            detailArr: [
                {
                    ques: "كيفية حذف الحساب؟",
                    answer: "لا يوجد لدينا خاصية حذف الحساب حيث إن طريقة تسجيل الدخول (فيسبوك - تويتر - جيميل - رقم الهاتف).",
                    answerItem: [],
                },
                {
                    ques: "كيفية تغيير رقم الحساب؟",
                    answer: "يمكنك تغيير رقم الحساب عند الحصول على وسام من اوسمة كبار المستخدمين",
                    answerItem: [],
                },
                {
                    ques: "كيفية اضافة او مسح رقم الهاتف الى الحساب؟",
                    answer: null,
                    answerItem: [
                        {
                            itemText: " من القائمة الرئيسية قم بالضغط على صورة حسابك."
                        },
                        {
                            itemText: " ثم قم باختيار الإعدادات ثم إدارة حسابي."
                        },
                        {
                            itemText: " اختار رقم الهاتف."
                        },
                        {
                            itemText: "قم بالضغط على إضافة رقم أو حذف الرقم."
                        },
                    ]
                },
                {
                    ques: "كيفية تغيير طريقة الدخول؟",
                    answer: 'حساب لوبس مرتبط وبشكل كامل بقناة الاتصال التي تم إنشاء الحساب بها "تويتر، فيسبوك، بريد جوجل، أو رقم الهاتف" لا توجد خاصية تغيير القناة المتصلة بالحساب لقناة اتصال أخرى.  ',
                    answerItem: [
        
                    ]
                },
                {
                    ques: " كيفية تعيين كلمة مرور للحساب؟",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "من خلال تسجيل الدخول برقم الهاتف."
                        },
                        {
                            itemText: "يمكنك الضغط على تعيين كلمة مرور."
                        },
                        {
                            itemText: "اختيار كلمة مرور مكونة من 6 (حروف - أرقام)."
                        },
                        {
                            itemText: "الضغط على تأكيد."
                        },
                    ]
                },
            ]
        },
        {
            title: "حظر الحساب",
            desc: null,
            detailArr: [
                {
                    ques: "اسباب حظر الحساب؟",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "العنصرية أو الحقد السياسي."
                        },
                        {
                            itemText: "دعوة المستخدمين لبرنامج منافس، أو ترك البرنامج."
                        },
                        {
                            itemText: "اختراق الحسابات أو الاحتيال."
                        },
                        {
                            itemText: "السب أو القذف أو اهانة أي مستخدم أو مجموعة."
                        },
                    ]
                },
                {
                    ques: "كيفية البلاغ من التطبيق؟",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "الضغط على صورة الحساب المسيء."
                        },
                        {
                            itemText: 'الضغط على "تبليغ".'
                        },
                        {
                            itemText: "اختيار نوع الاساءة الضغط على ارسال."
                        },
                    ]
                },
            ]
        },
        {
            title: "طرق الشحن",
            desc: null,
            detailArr: [
                {
                    ques: "كيف أقوم بالشحن؟",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "الضغط على شحن الكوينز من الصفحة الشخصية."
                        },
                        {
                            itemText: "اختيار فئة الكوينز المراد شحنها."
                        },
                        {
                            itemText: "إتمام عملية الشراء من خلال حساب جوجل ومتجر أبل."
                        },
                    ]
                },
                {
                    ques: "لا استطيع الشحن، ماذا يجب ان افعل؟",
                    answer: "Help@loopslive.comيمكنك ارسال البيانات التالية الى البريد الإلكتروني ",
                    answerItem: [
                        {
                            itemText: "المبلغ الذي قد تم دفعه لشراء الكوينز."
                        },
                        {
                            itemText: "اليوم والتوقيت الذي تم فيه الدفع."
                        },
                        {
                            itemText: "فئة الكوينز التي تم شراؤها عدد مرات الشراء."
                        },
                        {
                            itemText: "صورة تدل على سحب المبلغ من الحساب المالي."
                        },
                        {
                            itemText: "رقم حسابك في لوبس."
                        },
                    ]
                },
                {
                    ques: "تحصيل النقود (Cash Out)؟",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "الضغط على رصيد الماس من خلال الصفحة الشخصية."
                        },
                        {
                            itemText: "الضغط على تحويل إلى كوينز."
                        },
                        {
                            itemText: "الضغط على التحصيل ليصلك خلال 21 يوم عمل كحد أقصى."
                        },
                        {
                            itemText: "القيام بتسجيل حساب على بايونير."
                        },
                        {
                            itemText: "يجب أن يكون حسابكم في مستوى 10 أو أكثر وأن يكون عدد الماس لديك ما لا يقل عن 30 ألف ماسة."
                        },
                        {
                            itemText: "سوف يصلك الكاش في حساب بايونير الخاص بك بعد الموافقة من خلالنا وبعد ذلك يمكنك تحويل الكاش من حسابك الخاص ببايونير للبنك المسجل الخاص بك."
                        },
                        {
                            itemText: "يتم عمل كاش اوت مرة واحدة كل 30 يوم."
                        }
                    ]
                },
            ]
        },
        {
            title: "البث الحي",
            desc: null,
            detailArr: [
                {
                    ques: "كيفية القيام بالبث؟",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "الضغط على علامة (+) من خلال الصفحة الشخصية."
                        },
                        {
                            itemText: "اختيار نوع البث (صوتي – فيديو)."
                        },
                    ]
                },
                {
                    ques: "؟(Guest) كيفية طلب الدخول للبث كضيف",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "طلب مكالمة قست من المستوى الثاني."
                        },
                        {
                            itemText: "الدخول على أي بث فيديو والضغط على علامة (-) من على يسار الصفحة."
                        },
                        {
                            itemText: "اختيار قست وارسال طلب."
                        },
                        {
                            itemText: "انتظار قبول صاحب البث."
                        },
                    ]
                },
                {
                    ques: "كيفية القيام بالبث الخاص؟ ",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "الضغط على علامة الذهاب الى البث (+) من خلال الصفحة الشخصية."
                        },
                        {
                            itemText: "اختيار نوع البث (صوت – فيديو)."
                        },
                        {
                            itemText: "الضغط على وضع الخاص."
                        },
                        {
                            itemText: "اختيار الباقة المناسبة."
                        },
                    ]
                },
                {
                    ques: "كيف اكون مذيع؟",
                    answer: "عند حصولك على أحد توثيقات المذيعين",
                    answerItem: [
                        {
                            itemText: "الوسام البرونزي (وصول الدعم الذي حصلت عليه 30,000 ماسة في الشهر)."
                        },
                        {
                            itemText: "الوسام الفضي (وصول الدعم الذي حصلت عليه 100,000ماسة في الشهر)."
                        },
                        {
                            itemText: "الوسام الذهبي (وصول الدعم الذي حصلت عليه 1,000,000ماسة في الشهر)."
                        },
                    ]
                },
                {
                    ques: "لا أستطيع القيام بالبث؟",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "التأكد من اتصالك بشبكة انترنت قوية، ومحاولة بدء البث مرة أخرى."
                        },
                        {
                            itemText: "مسح التطبيق وتحميله مرة أخرى."
                        },
                        {
                            itemText: "إذا كانت المشكلة لاتزال موجودة، نرجو إرسال صورة من الرسالة التي تظهر على شاشة الهاتف عند محاولة البث الى البريد الإلكتروني Help@loopsliv.com"
                        },
                        {
                            itemText: "يرجى إرسال تاريخ وتوقيت البث الذي بدأت فيه هذه المشكلة الى البريد الإلكتروني Help@loopslive.com"
                        },
                    ]
                },
            ]
        },
        {
            title: "النوادي والاشتراك",
            desc: null,
            detailArr: [
                {
                    ques: "كيفية انشاء نادى؟",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "الضغط على (بدء البث) من خلال الصفحة الشخصية."
                        },
                        {
                            itemText: "الضغط على البث الآن."
                        },
                        {
                            itemText: "الضغط على علامة النادي بجانب التعليقات."
                        },
                        {
                            itemText: "الضغط على ترقية."
                        },
                        {
                            itemText: "اختيار اسم وفئة النادي."
                        },
                    ]
                },
                {
                    ques: "كيفية الاشتراك بالنادي؟",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "الضغط على نوادي من خلال الصفحة الشخصية."
                        },
                        {
                            itemText: "الضغط على استكشف العضوية."
                        },
                        {
                            itemText: "اختيار باقة الاشتراك المناسبة لك (عادي - قياسي - ممتاز - ذهبي فاخر)."
                        },
                        {
                            itemText: "الضغط على اشترك الآن ثم إتمام الاشتراك من خلال حساب جوجل ومتجر أبل."
                        }
                    ]
                },
                {
                    ques: "ما هي مميزات الاشتراك بالنادي؟",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "رسائل طائرة مجانية."
                        },
                        {
                            itemText: "هدايا حصرية."
                        },
                        {
                            itemText: "20% نقاط EXP إضافية."
                        },
                        {
                            itemText: "مربع دردشة خاص."
                        },
                        {
                            itemText: "تأثيرات دخول خاصة."
                        },
                        {
                            itemText: "وسام المتابع الحصري."
                        }
                    ]
                },
                {
                    ques: "لا أستطيع الاشتراك في أي نادي؟",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "ارسال صورة من الرسالة التي تظهر لك عند محاولة الدخول الى أي نادى الى البريد الإلكتروني Help@loopsliv.com "
                        },
                        {
                            itemText: 'ارسال رقم الحساب وصورة من فاتورة اشتراكك الى البريد الإلكتروني Help@loopslive.com'
                        },
                    ]
                },
            ]
        },
        {
            title: "كبار المستخدمين VIP",
            desc: null,
            detailArr: [
                {
                    ques: "كيف اكون من كبار المستخدمين؟",
                    answer: "عند حصولك على أي وسام من اوسمة كبار المستخدمين:",
                    answerItem: [
                        {
                            itemText: "وسام الفارس (وصول انفاقك للكوينز الى 500,000 من بداية الدخول للتطبيق)."
                        },
                        {
                            itemText: "وسام اللورد (وصول انفاقك للكوينز الى 1,500,000 من بداية الدخول للتطبيق)."
                        },
                        {
                            itemText: "وسام الوزير (وصول انفاقك للكوينز الى 3,125,000 من بداية الدخول للتطبيق)."
                        },
                        {
                            itemText: "وسام البرنس (وصول انفاقك للكوينز الى 12,500,000 من بداية الدخول للتطبيق)."
                        },
                        {
                            itemText: "وسام الملك (وصول انفاقك للكوينز الى 35,000,000 من بداية الدخول للتطبيق)."
                        },
                    ]
                },
                {
                    ques: "كيفية الحفاظ على الوسام كل شهر؟",
                    answer: "يمكنك الحفاظ على الوسام الخاص بك كل شهر عند إنفاق التالي:",
                    answerItem: [
                        {
                            itemText: "وسام الفارس (50,000 كوينز)."
                        },
                        {
                            itemText: "وسام اللورد (150,000 كوينز)."
                        },
                        {
                            itemText: "وسام الوزير (312,000 كوينز)."
                        },
                        {
                            itemText: "وسام البرنس (1,000,000 كوينز)."
                        },
                        {
                            itemText: "وسام الملك (2,100,000 كوينز)."
                        },
                    ]
                },
            ]
        },
        {
            title: "الحارس الشخصي",
            desc: null,
            detailArr: [
                {
                    ques: "ما هي مميزات الحارس الشخصي؟",
                    answer: null,
                    answerItem: [
                        {
                            itemText: "صورة الحارس."
                        },
                        {
                            itemText: "تأثير دخول خاص."
                        },
                        {
                            itemText: "مربع دردشة خاص."
                        },
                        {
                            itemText: "5 اضعاف EXP حسب سعر العرض."
                        }
                    ]
                }
            ]
        },
    ]
}


export { newQusArrData, popularQuesData }


// WEBPACK FOOTER //
// ./src/json/data.js